import { ValidationMessage } from '@common/model';

/**
   * Formats validation messages for display, filtering out stack traces and truncating long technical errors
   */
export function getValidationSummary(validationMessages: ValidationMessage[]): string | null {
    if (!validationMessages || validationMessages.length === 0) {
      return null;
    }

    const maxLength = 120; // Arbitrary length limit to avoid long error messages
    const stackTraceIndicators = ['.cs', '.js', '.ts', 'Exception', 'at line', 'StackTrace', 'at System.', 'at Microsoft.'];

    // Filter out messages that look like stack traces, but keep long messages
    const userFriendlyMessages = validationMessages.filter(vm => {
      const message = vm.Message || '';
      const hasStackTraceIndicators = stackTraceIndicators.some(indicator => message.includes(indicator));
      
      return !hasStackTraceIndicators;
    });

    if (userFriendlyMessages.length === 0) {
      return null; // All messages were filtered out as stack traces
    }

    if (userFriendlyMessages.length === 1) {
      const message = userFriendlyMessages[0].Message;
      
      return message.length <= maxLength ? message : `${message.substring(0, maxLength - 3)}...`;
    }

    // Multiple messages - show first + count, truncating if needed
    const firstMessage = userFriendlyMessages[0].Message;
    const additionalCount = userFriendlyMessages.length - 1;
    const countText = ` (and ${additionalCount} more error${additionalCount > 1 ? 's' : ''})`;
    const availableSpaceForFirstMessage = maxLength - countText.length;
    
    const truncatedFirstMessage = firstMessage.length <= availableSpaceForFirstMessage 
      ? firstMessage 
      : `${firstMessage.substring(0, availableSpaceForFirstMessage - 3)}...`;

    const summary = `${truncatedFirstMessage}${countText}`;
    
    return summary;
  }